module.exports = __webpack_public_path__ + "img/logo-full.921df98d.svg";